<template>
  <div class="home">
<!--    <GlobalNoticesBlock></GlobalNoticesBlock>-->
<!--    <div style="width: 800px">-->
<!--    <div class="block">-->
<!--      <div class="block__content">-->
<!--        <HistoryExportBlock-->
<!--          accountNumber="U100232"-->
<!--          periodBegin="01.01.2022"-->
<!--          periodEnd="01.01.2024"/>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

    <div class="block">
      <div class="block__content">
    <DepositUsdtTransferPage />
      </div>
    </div>

<!--    <div style="background: #333; margin: 2rem 0; padding: 5rem; ">-->
<!--      <IntroAchievements></IntroAchievements>-->
<!--    </div>-->

    <br/><br/>
<!--    <div class="block">-->
<!--      <div class="block__content">-->
<!--        <div class="tile personal-info__data">-->
<!--          <div class="personal-info__data_left text-center">-->
<!--            <div class="avatar-upload">-->
<!--              <div class="avatar-wrap">-->
<!--                <div class="pre-loader-wrap" style="display: none;">-->
<!--                  <div class="sk-fading-circle">-->
<!--                    <div class="sk-circle1 sk-circle"></div>-->
<!--                    <div class="sk-circle2 sk-circle"></div>-->
<!--                    <div class="sk-circle3 sk-circle"></div>-->
<!--                    <div class="sk-circle4 sk-circle"></div>-->
<!--                    <div class="sk-circle5 sk-circle"></div>-->
<!--                    <div class="sk-circle6 sk-circle"></div>-->
<!--                    <div class="sk-circle7 sk-circle"></div>-->
<!--                    <div class="sk-circle8 sk-circle"></div>-->
<!--                    <div class="sk-circle9 sk-circle"></div>-->
<!--                    <div class="sk-circle10 sk-circle"></div>-->
<!--                    <div class="sk-circle11 sk-circle"></div>-->
<!--                    <div class="sk-circle12 sk-circle"></div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="controls"><a href="#" class="avatar-remove" style="display: none;"><span-->
<!--                  class="glyphicon glyphicon-remove"></span></a></div>-->
<!--                <div class="avatar">-->
<!--                  <div-->
<!--                    style="width: 140px; height: 140px; background-image: url(&quot;/assets/42f49965/layout/images/ava9.png&quot;); background-size: cover; background-repeat: no-repeat; background-position: 50% 50%;"></div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <a href="#" class="avatar-edit">Выбрать изображение<input type="file"-->
<!--                                                                        style="display: none;"></a>-->
<!--              <div class="avatar-upload-browse-hint">Допустимы PNG, JPG размером до 200 Кбайт.</div>-->
<!--            </div>-->
<!--            <p>Статус: <b>Верифицированный</b></p>-->
<!--            <div class="personal-info__status"><span class="cap-icon cap-icon-check"></span> <span>Подтвержден</span>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="personal-info__data_right">-->
<!--            <table class="table table_horizontal table_no-border table-striped odd table_pd-md">-->
<!--              <tbody>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  Имя пользователя-->
<!--                </td>-->
<!--                <td>-->
<!--                  raymanlegal (бизнес)-->
<!--                </td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  Никнейм-->
<!--                </td>-->
<!--                <td>-->
<!--                  <div><a id="nickname" data-title="Никнейм" data-value="raymanlegal"-->
<!--                          data-property-name="nickname" data-placeholder="не указан"-->
<!--                          data-message-fail="Не удалось изменить." href="#"-->
<!--                          class="link-hovered edit-nickname available_for_edit editable editable-click">raymanlegal</a>-->
<!--                  </div>-->
<!--                  <br>-->
<!--                  <div><small>-->
<!--                    Никнейм будет доступен всем пользователям, отправляющим вам платежи или-->
<!--                    принимающим их от вас.-->
<!--                    По вашему желанию логин и никнейм могут как совпадать, так и-->
<!--                    отличаться. </small></div>-->
<!--                </td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  E-mail:-->
<!--                </td>-->
<!--                <td><a href="/security/email" class="link-hovered">evangelion2233@yopmail.com</a>-->
<!--                </td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  Контактный телефон:-->
<!--                </td>-->
<!--                <td><a id="contact_phone" data-title="Контактный телефон" data-value="1232323233"-->
<!--                       data-contact-type="phone" data-placeholder="не указан"-->
<!--                       data-message-fail="Не удалось изменить." href="#"-->
<!--                       class="link-hovered available_for_edit editable-contact editable editable-click">1232323233</a>-->
<!--                </td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  Telegram-->
<!--                </td>-->
<!--                <td><a id="contact_telegram" data-title="Telegram" data-contact-type="telegram"-->
<!--                       data-placeholder="не указан" data-message-fail="Не удалось изменить."-->
<!--                       href="#"-->
<!--                       class="link-hovered available_for_edit editable-contact editable editable-click editable-empty">не-->
<!--                  указан</a></td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  WhatsApp-->
<!--                </td>-->
<!--                <td><a id="contact_whatsapp" data-title="WhatsApp" data-value="551199999111"-->
<!--                       data-contact-type="whatsapp" data-placeholder="не указан"-->
<!--                       data-message-fail="Не удалось изменить." href="#"-->
<!--                       class="link-hovered available_for_edit editable-contact editable editable-click">551199999111</a>-->
<!--                </td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  Skype-->
<!--                </td>-->
<!--                <td><a id="contact_phone" data-title="Skype" data-value="sdfdf3432"-->
<!--                       data-contact-type="skype" data-placeholder="не указан"-->
<!--                       data-message-fail="Не удалось изменить." href="#"-->
<!--                       class="link-hovered available_for_edit editable-contact editable editable-click">sdfdf3432</a>-->
<!--                </td>-->
<!--              </tr>-->
<!--              <tr>-->
<!--                <td>-->
<!--                  Категория-->
<!--                </td>-->
<!--                <td>-->
<!--                  <FrontofficeUserCategoryInlineSelect />-->
<!--                </td>-->
<!--              </tr>-->
<!--              </tbody>-->
<!--            </table>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->

<!--    <div class="block">-->
<!--      <div class="block__content">-->
<!--          <TestPayoutBlock></TestPayoutBlock>-->
<!--      </div>-->
<!--    </div>-->

    <div class="block">
      <div class="block__content">
        <VerificationTypesPanel></VerificationTypesPanel>
      </div>
    </div>
    <!--    // GlobalNoticesBlock-->
    <!--    //AccountsPageBannersSlider-->
    <!--    //.block-->
    <!--      .block__content-->

    <!--        // SecuritySetupThirdpartyAnalytics-->

    <!--        //FeesCardsWarnings-->
    <!--        //ProfileUpdateSelect-->
    <!--    //walleto-terms-update2022-alert()-->

    <!--    //autosplit-dialog-modal(ref="dialog")-->
    <!--    //button.btn.btn-success(@click.prevent="testAskClick") Test ask-->
    <!--    //usdt-addresses-window(ref="usdtModal")-->
    <!--    //walleto-refund-alert-->
    <!--    //.block-->
    <!--      .block__content-->
    <!--        history-table(:documents="docs")-->
    <!--    //button(@click="showAgreement") Показать агримент-->
    <!--    //walleto-blocking-warning-modal(ref="blockingModal")-->
    <!--    //walleto-kyc-reset-warning-modal-->
    <!--    //walleto-kyc-reset-warning-payout-hint-->
    <!--    //support-review(reqid="123")-->
    <!--    // document-beneficiary-link(beneficiary="Beneficiary" :is-capitalist-beneficiary="true" searchLink="https://www.google.com")-->

    <!--    // deposit-usd-via-qiwi-page-->
    <!--    // deposit-usdt-cardtransfer-page-->
    <!--    // .block__content-->
    <!--      eth-transaction-search-notice-->
    <!--      //profile-update-required-crypto-notice-->



    <!--    //.block-->
    <!--      .block__content-->
    <!--        -->
    <!--        //test-payout-block-->
    <!--      //deposit-usdt-cardtransfer-page-->
    <!--    //.block-->
    <!--      // .block__content-->
    <!--        //test-payout-block-->
    <!--      deposit-usd-via-qiwi-page-->
    <!--    // deposit-usdc-transfer-page-->
    <!--    //verification-types-panel-->
    <!--    //security-setup-thirdparty-analytics-->

    <!--      //div-->
    <!--        history-account-entries-download-button(account-number="" period-begin="" period-end="")-->
    <!--        history-account-entries-download-button(account-number="U0100200" period-begin="01.10.2020" period-end="01.10.2020")-->
    <!--      //mercuryo-deposit-block-->
    <!--    //global-notices-block-->

  </div>

</template>

<script lang="ts">
import Vue from 'vue';

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
//import ContactsSocialsBlock from "@/views/pages/contacts/ContactsSocialsBlock";
//import LegacyBootstrapDatepicker from "@/views/pages/basic/LegacyBootstrapDatepicker";
// import QiwiDepositBlock from "@/views/pages/finance/deposit/QiwiDepositBlock";
import MercuryoDepositBlock from "@/views/pages/finance/deposit/MercuryoDepositBlock.vue";
// import BuyCryptoPage from "@/views/pages/finance/deposit/BuyCryptoPage";
import UsdtAddressesWindow from "@/views/pages/finance/accounts/crypto/UsdtAddressesWindow.vue";
import {Component} from "vue-property-decorator";
import GlobalNoticesBlock from "@/views/pages/global/GlobalNoticesBlock.vue";
import TestPayoutBlock from "@/views/pages/finance/payout/TestPayoutFormBlock.vue";
import HistoryAccountEntriesDownloadButton
  from "@/components/history/HistoryAccountEntriesDownloadButton.vue";


import AutosplitDialogModal from "@/views/pages/finance/payout/AutosplitDialogModal.vue";
import {MoneyAmount} from "@/models/finance/money";
import {CurrencyCode} from "@/models/core/currency";
import WalletoKycResetWarningModal
  from "@/views/pages/global/notices/WalletoKycResetWarningModal.vue";
import WalletoKycResetWarningPayoutHint
  from "@/views/pages/global/notices/WalletoKycResetWarningPayoutHint.vue";
import WalletoBlockingWarningModal
  from "@/views/pages/global/notices/walleto/WalletoBlockingWarningModal.vue";
import WalletoRefundAlert from "@/views/pages/global/notices/walleto/WalletoRefundAlert.vue";
import ProfileUpdateRequiredCryptoNotice
  from "@/views/pages/finance/accounts/crypto/notice/ProfileUpdateRequiredCryptoNotice.vue";
import SecuritySetupThirdpartyAnalytics
  from "@/views/pages/security/setup/SecuritySetupThirdpartyAnalytics.vue";
import VerificationTypesPanel from "@/views/pages/security/setup/VerificationTypesPanel.vue";
import DocumentDetailsModal
  from "@/backoffice/components/pages/gate/stuck/DocumentDetailsModal.vue";
import DocumentDetails from "@/views/pages/finance/history/DocumentDetails.vue";
import SupportReview from "@/views/pages/support/SupportReview.vue";
import EthTransactionSearch from "@/views/pages/finance/tools/EthTransactionSearch.vue";
import EthTransactionSearchNotice from "@/views/pages/finance/tools/EthTransactionSearchNotice.vue";
import DepositUsdtCardtransferPage
  from "@/views/pages/finance/deposit/usdt/DepositUsdtCardtransferPage.vue";
import DepositUsdViaQiwiPage from "@/views/pages/finance/deposit/usdt/DepositUsdViaQiwiPage.vue";
import DepositUsdtTransferPage
  from "@/views/pages/finance/deposit/usdt/DepositUsdtTransferPage.vue";
import DepositUsdcTransferPage
  from "@/views/pages/finance/deposit/usdc/DepositUsdcTransferPage.vue";
import DocumentBeneficiaryLink from "@/views/pages/finance/history/DocumentBeneficiaryLink.vue";
import HistoryTable from "@/views/pages/finance/history/HistoryTable.vue";
import WalletoTermsUpdate2022Alert
  from "@/views/pages/global/notices/walleto/WalletoTermsUpdate2022Alert.vue";
import IntroAchievements from "@/views/pages/main/IntroAchievements.vue";
import HeaderAchievements from "@/views/pages/main/HeaderAchievements.vue";
import ProfileUpdateSelect from "@/views/pages/profile/ProfileUpdateSelect.vue";
import FeesCardsWarnings from "@/views/pages/fees/FeesCardsWarnings.vue";
import AccountsPageBannersSlider
  from "@/views/pages/finance/accounts/banners/AccountsPageBannersSlider.vue";
import FrontofficeUserCategoryInlineSelect
  from "@/views/pages/profile/FrontofficeUserCategoryInlineSelect.vue";
import HistoryCsvDownloadButtonNew from "@/components/history/HistoryCsvDownloadButtonNew.vue";
import HistoryExportBlock from "@/components/history/HistoryExportBlock.vue";


@Component({
  name: 'home',
  components: {
    HistoryExportBlock,
    HistoryCsvDownloadButtonNew,
    FrontofficeUserCategoryInlineSelect,
    AccountsPageBannersSlider,
    FeesCardsWarnings,
    ProfileUpdateSelect,
    HeaderAchievements,
    IntroAchievements,
    WalletoTermsUpdate2022Alert,
    HistoryTable,
    DocumentBeneficiaryLink,
    DepositUsdcTransferPage,
    DepositUsdtTransferPage,
    DepositUsdViaQiwiPage,
    DepositUsdtCardtransferPage,
    EthTransactionSearchNotice,
    EthTransactionSearch,
    SupportReview,
    DocumentDetails,
    DocumentDetailsModal,
    VerificationTypesPanel,
    SecuritySetupThirdpartyAnalytics,
    ProfileUpdateRequiredCryptoNotice,
    WalletoRefundAlert,
    WalletoKycResetWarningModal,
    WalletoKycResetWarningPayoutHint,
    HistoryAccountEntriesDownloadButton,
    TestPayoutBlock,
    GlobalNoticesBlock,
    MercuryoDepositBlock,
    UsdtAddressesWindow,
    AutosplitDialogModal,
    WalletoBlockingWarningModal

    //BuyCryptoPage,
    // MercuryoDepositBlock,
    // QiwiDepositBlock,
    // LegacyBootstrapDatepicker,
    // ContactsSocialsBlock,
    // HelloWorld
  }
})
export default class Home extends Vue {

  mounted() {
    if (this.$refs.usdtModal)
      (this.$refs.usdtModal as any).openModal();

    //this.$refs.dialog.showModal();
  }

  showAgreement() {
    (this.$refs.blockingModal as WalletoBlockingWarningModal).refresh();
  }

  testAskClick() {
    this.testAsk().then((result) => {
      console.log('test ask', result);
    }).catch((result) => {
      console.log('test ask errot', result);
    })
  }

  testAsk() {
    return (this.$refs.dialog as any).ask(new MoneyAmount(1032320.12, CurrencyCode.USD));
  }

  docs = [
    {
      "id": 96422100,
      "docNumber": 96422100,
      "created": 1657019123,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 8.79,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 8.79,
      "destCurrency": "EUR",
      "actualAmount": 8.79,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "{\"orderReference\":\"PF-ORDER87911657019133108\",\"customOrderReference\":\"96422100\",\"code\":\"TESTCODE\",\"serial\":\"testSerial\",\"codeType\":\"TEXT\"}",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96422100",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": {
        "skudata": {
          "sku": "Neosurf-10-AUD",
          "productName": "Neosurf 10 AUD",
          "codeType": "TEXT"
        },
        "result": {
          "orderReference": "PF-ORDER87911657019133108",
          "customOrderReference": "96422100",
          "code": "TESTCODE",
          "serial": "testSerial",
          "codeType": "TEXT"
        }
      }
    },
    {
      "id": 96421979,
      "docNumber": 96421979,
      "created": 1656927440,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 100,
      "currency": "USD",
      "tax": 0,
      "destAmount": 100,
      "destCurrency": "USD",
      "actualAmount": 100,
      "actualCurrency": "USD",
      "description": "BatchTest",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Выпуск карты",
      "channelType": null,
      "comment": "",
      "batch": {
        "id": "d02bbc1f-0ba4-41a2-b4b9-dbaafa5d5e09",
        "number": "3",
        "type": "ISSUED",
        "timestamp": 1656927414
      },
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421979",
      "verificationType": "BATCH",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "U0100652",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421957,
      "docNumber": 96421957,
      "created": 1656927440,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 20,
      "currency": "USD",
      "tax": 0,
      "destAmount": 20,
      "destCurrency": "USD",
      "actualAmount": 20,
      "actualCurrency": "USD",
      "description": "BatchTest",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Выпуск карты",
      "channelType": null,
      "comment": "",
      "batch": {
        "id": "d02bbc1f-0ba4-41a2-b4b9-dbaafa5d5e09",
        "number": "2",
        "type": "ISSUED",
        "timestamp": 1656927414
      },
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421957",
      "verificationType": "BATCH",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "U0100652",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421935,
      "docNumber": 96421935,
      "created": 1656927440,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 40,
      "currency": "USD",
      "tax": 0,
      "destAmount": 40,
      "destCurrency": "USD",
      "actualAmount": 40,
      "actualCurrency": "USD",
      "description": "BatchTest",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Выпуск карты",
      "channelType": null,
      "comment": "",
      "batch": {
        "id": "d02bbc1f-0ba4-41a2-b4b9-dbaafa5d5e09",
        "number": "1",
        "type": "ISSUED",
        "timestamp": 1656927414
      },
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421935",
      "verificationType": "BATCH",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "U0100652",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421858,
      "docNumber": 96421858,
      "created": 1656696541,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 6.98,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 6.98,
      "destCurrency": "EUR",
      "actualAmount": 6.98,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "{\"orderReference\":\"PF-ORDER87911656696554867\",\"customOrderReference\":\"96421858\",\"code\":\"TESTCODE\",\"serial\":\"testSerial\",\"codeType\":\"TEXT\"}",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421858",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": {
        "skudata": {
          "sku": "Amazon-5-USD",
          "productName": "Amazon 5 USD",
          "codeType": "TEXT"
        },
        "result": {
          "orderReference": "PF-ORDER87911656696554867",
          "customOrderReference": "96421858",
          "code": "TESTCODE",
          "serial": "testSerial",
          "codeType": "TEXT"
        }
      }
    },
    {
      "id": 96421847,
      "docNumber": 96421847,
      "created": 1656696535,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 6.98,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 6.98,
      "destCurrency": "EUR",
      "actualAmount": 6.98,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "Отменен. Платеж не подписан пользователем.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421847",
      "verificationType": "SMS подтверждение",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421825,
      "docNumber": 96421825,
      "created": 1656685144,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 6.98,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 6.98,
      "destCurrency": "EUR",
      "actualAmount": 6.98,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "{\"orderReference\":\"PF-ORDER87911656685161513\",\"customOrderReference\":\"96421825\",\"code\":\"TESTCODE\",\"serial\":\"testSerial\",\"codeType\":\"TEXT\"}",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421825",
      "verificationType": "SMS подтверждение",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": {
        "skudata": {
          "sku": "Amazon-5-USD",
          "productName": "Amazon 5 USD",
          "codeType": "TEXT"
        },
        "result": {
          "orderReference": "PF-ORDER87911656685161513",
          "customOrderReference": "96421825",
          "code": "TESTCODE",
          "serial": "testSerial",
          "codeType": "TEXT"
        }
      }
    },
    {
      "id": 96421803,
      "docNumber": 96421803,
      "created": 1656684830,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 6.98,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 6.98,
      "destCurrency": "EUR",
      "actualAmount": 6.98,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "{\"orderReference\":\"PF-ORDER87911656685020437\",\"customOrderReference\":\"96421803\",\"code\":\"TESTCODE\",\"serial\":\"testSerial\",\"codeType\":\"TEXT\"}",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421803",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": {
        "skudata": {
          "sku": "Amazon-5-USD",
          "productName": "Amazon 5 USD",
          "codeType": "TEXT"
        },
        "result": {
          "orderReference": "PF-ORDER87911656685020437",
          "customOrderReference": "96421803",
          "code": "TESTCODE",
          "serial": "testSerial",
          "codeType": "TEXT"
        }
      }
    },
    {
      "id": 96421781,
      "docNumber": 96421781,
      "created": 1656683985,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 6.98,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 6.98,
      "destCurrency": "EUR",
      "actualAmount": 6.98,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "{\"orderReference\":\"PF-ORDER87911656683995223\",\"customOrderReference\":\"96421781\",\"code\":\"TESTCODE\",\"serial\":\"testSerial\",\"codeType\":\"TEXT\"}",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421781",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": {
        "skudata": {
          "sku": "Amazon-5-USD",
          "productName": "Amazon 5 USD",
          "codeType": "TEXT"
        },
        "result": {
          "orderReference": "PF-ORDER87911656683995223",
          "customOrderReference": "96421781",
          "code": "TESTCODE",
          "serial": "testSerial",
          "codeType": "TEXT"
        }
      }
    },
    {
      "id": 96421759,
      "docNumber": 96421759,
      "created": 1656680692,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 7.65,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 7.65,
      "destCurrency": "EUR",
      "actualAmount": 7.65,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "Платеж не может быть исполнен в данный момент. Повторите попытку позднее.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421759",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421737,
      "docNumber": 96421737,
      "created": 1656680625,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 7.65,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 7.65,
      "destCurrency": "EUR",
      "actualAmount": 7.65,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "Платеж не может быть исполнен в данный момент. Повторите попытку позднее.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421737",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421726,
      "docNumber": 96421726,
      "created": 1656680607,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 7.65,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 7.65,
      "destCurrency": "EUR",
      "actualAmount": 7.65,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "Отменен. Платеж не подписан пользователем.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421726",
      "verificationType": "SMS подтверждение",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421693,
      "docNumber": 96421693,
      "created": 1656667090,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 27.43,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 27.43,
      "destCurrency": "EUR",
      "actualAmount": 27.43,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "Платеж не может быть исполнен в данный момент. Повторите попытку позднее.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421693",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421682,
      "docNumber": 96421682,
      "created": 1656667083,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 27.43,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 27.43,
      "destCurrency": "EUR",
      "actualAmount": 27.43,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "Отменен. Платеж не подписан пользователем.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421682",
      "verificationType": "SMS подтверждение",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421660,
      "docNumber": 96421660,
      "created": 1656666729,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 27.43,
      "currency": "EUR",
      "tax": 0,
      "destAmount": 27.43,
      "destCurrency": "EUR",
      "actualAmount": 27.43,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "Платеж не может быть исполнен в данный момент. Повторите попытку позднее.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96421660",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96421627,
      "docNumber": 96421627,
      "created": 1656597274,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 111,
      "currency": "USD",
      "tax": 2.78,
      "destAmount": 51084.47,
      "destCurrency": "KZT",
      "actualAmount": 111,
      "actualCurrency": "USD",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Банковская карта Казахстана",
      "channelType": "kzcards",
      "comment": "",
      "batch": {
        "id": "b933b268-3385-48c8-ace4-99f050dc2601",
        "number": "9999",
        "type": "KZCARD",
        "timestamp": 1656591815
      },
      "repeatable": true,
      "repeatUrl": "/finance/payout/kzcards/96421627",
      "verificationType": "BATCH",
      "beneficiary": "52019512****6725",
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/52019512%2A%2A%2A%2A6725",
      "historyBeneficiarySearchAvailable": true,
      "sender": "U0100020",
      "receiver": "52019512****6725",
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96064611,
      "docNumber": 96064611,
      "created": 1656585049,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 15.37,
      "currency": "EUR",
      "tax": 35,
      "destAmount": 15.37,
      "destCurrency": "EUR",
      "actualAmount": 15.37,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "{\"orderReference\":\"PF-ORDER87911656585057604\",\"customOrderReference\":\"96064611\",\"code\":\"TESTCODE\",\"serial\":\"testSerial\",\"codeType\":\"TEXT\"}",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96064611",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": {
        "skudata": {
          "sku": "Neosurf-20-AUD",
          "productName": "Neosurf 20 AUD",
          "codeType": "TEXT"
        },
        "result": {
          "orderReference": "PF-ORDER87911656585057604",
          "customOrderReference": "96064611",
          "code": "TESTCODE",
          "serial": "testSerial",
          "codeType": "TEXT"
        }
      }
    },
    {
      "id": 96064589,
      "docNumber": 96064589,
      "created": 1656585022,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 15.37,
      "currency": "EUR",
      "tax": 35,
      "destAmount": 15.37,
      "destCurrency": "EUR",
      "actualAmount": 15.37,
      "actualCurrency": "EUR",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Покупка товара в маркетплейсе",
      "channelType": null,
      "comment": "{\"orderReference\":\"PF-ORDER87911656585031557\",\"customOrderReference\":\"96064589\",\"code\":\"TESTCODE\",\"serial\":\"testSerial\",\"codeType\":\"TEXT\"}",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96064589",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "E0100744",
      "receiver": null,
      "tx": null,
      "prepaid": {
        "skudata": {
          "sku": "Neosurf-20-AUD",
          "productName": "Neosurf 20 AUD",
          "codeType": "TEXT"
        },
        "result": {
          "orderReference": "PF-ORDER87911656585031557",
          "customOrderReference": "96064589",
          "code": "TESTCODE",
          "serial": "testSerial",
          "codeType": "TEXT"
        }
      }
    },
    {
      "id": 96064578,
      "docNumber": 96064578,
      "created": 1656584923,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 100,
      "currency": "USD",
      "tax": 0,
      "destAmount": 45954.17,
      "destCurrency": "KZT",
      "actualAmount": 100,
      "actualCurrency": "USD",
      "description": "Payout",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Банковская карта Казахстана",
      "channelType": "kzcards",
      "comment": "Отменен. Платеж не подписан пользователем.",
      "batch": {
        "id": "1745dc5e-7f59-4219-abdc-2f5af172a1a2",
        "number": null,
        "type": null,
        "timestamp": 1656584923
      },
      "repeatable": true,
      "repeatUrl": "/finance/payout/kzcards/96064578",
      "verificationType": "BATCH",
      "beneficiary": "44004301****8810",
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/44004301%2A%2A%2A%2A8810",
      "historyBeneficiarySearchAvailable": true,
      "sender": "U9999999",
      "receiver": "44004301****8810",
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96064545,
      "docNumber": 96064545,
      "created": 1656581586,
      "state": "executed",
      "inprocessmanual": false,
      "stateLocalized": "Исполнен",
      "amount": 10,
      "currency": "USD",
      "tax": 0,
      "destAmount": 10,
      "destCurrency": "USD",
      "actualAmount": 10,
      "actualCurrency": "USD",
      "description": "Issue virtual card",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Выпуск карты",
      "channelType": null,
      "comment": "",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96064545",
      "verificationType": "Платежный PIN-код",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "U0100020",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96064534,
      "docNumber": 96064534,
      "created": 1656580999,
      "state": "declined",
      "inprocessmanual": false,
      "stateLocalized": "Отклонен",
      "amount": 50,
      "currency": "USD",
      "tax": 0,
      "destAmount": 50,
      "destCurrency": "USD",
      "actualAmount": 50,
      "actualCurrency": "USD",
      "description": "Issue virtual card",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Выпуск карты",
      "channelType": null,
      "comment": "Отменен. Платеж не подписан пользователем.",
      "batch": null,
      "repeatable": false,
      "repeatUrl": "/finance/payout//96064534",
      "verificationType": "SMS подтверждение",
      "beneficiary": null,
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/",
      "historyBeneficiarySearchAvailable": false,
      "sender": "U0100020",
      "receiver": null,
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96064490,
      "docNumber": 96064490,
      "created": 1656507915,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 67.26,
      "currency": "USD",
      "tax": 1.69,
      "destAmount": 67.26,
      "destCurrency": "USD",
      "actualAmount": 67.26,
      "actualCurrency": "USD",
      "description": "Split me",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Банковская карта Украины",
      "channelType": "uacards",
      "comment": "",
      "batch": null,
      "repeatable": true,
      "repeatUrl": "/finance/payout/uacards/96064490",
      "verificationType": "SMS подтверждение",
      "beneficiary": "54805848****9109",
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/54805848%2A%2A%2A%2A9109",
      "historyBeneficiarySearchAvailable": true,
      "sender": "U0100020",
      "receiver": "54805848****9109",
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96064468,
      "docNumber": 96064468,
      "created": 1656507915,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 488.79,
      "currency": "USD",
      "tax": 12.22,
      "destAmount": 488.79,
      "destCurrency": "USD",
      "actualAmount": 488.79,
      "actualCurrency": "USD",
      "description": "Split me",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Банковская карта Украины",
      "channelType": "uacards",
      "comment": "",
      "batch": null,
      "repeatable": true,
      "repeatUrl": "/finance/payout/uacards/96064468",
      "verificationType": "SMS подтверждение",
      "beneficiary": "54805848****9109",
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/54805848%2A%2A%2A%2A9109",
      "historyBeneficiarySearchAvailable": true,
      "sender": "U0100020",
      "receiver": "54805848****9109",
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96064446,
      "docNumber": 96064446,
      "created": 1656507915,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 488.79,
      "currency": "USD",
      "tax": 12.22,
      "destAmount": 488.79,
      "destCurrency": "USD",
      "actualAmount": 488.79,
      "actualCurrency": "USD",
      "description": "Split me",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Банковская карта Украины",
      "channelType": "uacards",
      "comment": "",
      "batch": null,
      "repeatable": true,
      "repeatUrl": "/finance/payout/uacards/96064446",
      "verificationType": "SMS подтверждение",
      "beneficiary": "54805848****9109",
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/54805848%2A%2A%2A%2A9109",
      "historyBeneficiarySearchAvailable": true,
      "sender": "U0100020",
      "receiver": "54805848****9109",
      "tx": null,
      "prepaid": null
    },
    {
      "id": 96064424,
      "docNumber": 96064424,
      "created": 1656507915,
      "state": "inprocess",
      "inprocessmanual": true,
      "stateLocalized": "В обработке",
      "amount": 488.79,
      "currency": "USD",
      "tax": 12.22,
      "destAmount": 488.79,
      "destCurrency": "USD",
      "actualAmount": 488.79,
      "actualCurrency": "USD",
      "description": "Split me",
      "outgoing": true,
      "selfExchange": false,
      "channel": "Банковская карта Украины",
      "channelType": "uacards",
      "comment": "",
      "batch": null,
      "repeatable": true,
      "repeatUrl": "/finance/payout/uacards/96064424",
      "verificationType": "SMS подтверждение",
      "beneficiary": "54805848****9109",
      "corrDetails": [],
      "historyBeneficiarySearchUrl": "/finance/history/m%5BtextSearch%5D/54805848%2A%2A%2A%2A9109",
      "historyBeneficiarySearchAvailable": true,
      "sender": "U0100020",
      "receiver": "54805848****9109",
      "tx": null,
      "prepaid": null
    }
  ]
}
</script>
